export default "__VITE_ASSET__b1a8819e__"